import { ModuleWithProviders, NgModule, Type } from '@angular/core'

import {
  ClientStoreInterface,
  HttpRequestInterceptor,
  HttpResponseInterceptor,
  NomenclatorServiceInterface,
  resolveCustomLoaderProvider,
} from '@flowx/core-sdk'

import { FlxProcessRendererComponent } from './process-renderer/process-renderer.component'
import {
  CustomLoader,
  FLX_CLIENT_STORE_CONFIG,
  FLX_COMPONENTS_CONFIG,
  FLX_CUSTOM_LOADER_CONFIG,
  FLX_NOMENCLATOR_CONFIG,
  FLX_REQUEST_INTERCEPTORS_CONFIG,
  FLX_RESPONSE_INTERCEPTORS_CONFIG,
  FLX_VALIDATORS_CONFIG,
} from './services/providers'
import { NgSyncValidator } from './utils/validators'

export type { CustomLoader }

export type FlxConfig = {
  validators?: Record<string, NgSyncValidator>
  components?: Record<string, Type<any>>
  services?: {
    LocalDataStoreService?: Type<ClientStoreInterface>
    NomenclatorService?: Type<NomenclatorServiceInterface>
  }
  requestInterceptors?: HttpRequestInterceptor[]
  responseInterceptors?: HttpResponseInterceptor[]
  /** Host loader replacements per kind: startProcess, reloadProcess, defaultAction, defaultUpload, actions. */
  customLoaderProvider?: CustomLoader
  /** @deprecated Use `customLoaderProvider` instead. Kept for backward compatibility; removal will be announced. */
  customLoader?: CustomLoader
}

@NgModule({
  imports: [FlxProcessRendererComponent],
  exports: [FlxProcessRendererComponent],
})
export class FlxProcessModule {
  static withConfig({
    validators,
    components,
    services,
    customLoaderProvider,
    customLoader,
    requestInterceptors,
    responseInterceptors,
  }: FlxConfig): ModuleWithProviders<FlxProcessModule> {
    return {
      ngModule: FlxProcessModule,
      providers: [
        {
          provide: FLX_VALIDATORS_CONFIG,
          useValue: validators,
        },
        {
          provide: FLX_COMPONENTS_CONFIG,
          useValue: components,
        },
        {
          provide: FLX_CUSTOM_LOADER_CONFIG,
          useValue: resolveCustomLoaderProvider({ customLoader, customLoaderProvider }),
        },
        ...(services?.LocalDataStoreService
          ? [
              {
                provide: FLX_CLIENT_STORE_CONFIG,
                useExisting: services.LocalDataStoreService,
              },
            ]
          : []),
        ...(services?.NomenclatorService
          ? [
              {
                provide: FLX_NOMENCLATOR_CONFIG,
                useExisting: services.NomenclatorService,
              },
            ]
          : []),
        ...(requestInterceptors
          ? [{ provide: FLX_REQUEST_INTERCEPTORS_CONFIG, useValue: requestInterceptors }]
          : []),
        ...(responseInterceptors
          ? [{ provide: FLX_RESPONSE_INTERCEPTORS_CONFIG, useValue: responseInterceptors }]
          : []),
      ],
    }
  }
}
